const getters = {
    //app
    // test: state => state.app.test,
    headMenuTree: state => state.app.headMenuTree,
    isJumpMenuAnchor: state => state.app.isJumpMenuAnchor,
    isShowAppStore: state => state.app.isShowAppStore,
    noticeTotal:state => state.app.noticeTotal,//通知总数
    mailUnReadNum:state => state.app.mailUnReadNum,//邮件未读数
    noticeUnReadNum:state => state.app.noticeUnReadNum,//未读通知总数
    trainMsgUnReadNum:state => state.app.trainMsgUnReadNum,//培训未读消息数
    actMsgUnReadNum:state => state.app.actMsgUnReadNum,//活动未读消息数
    //用户
    admin:state => state.user.admin,
    userInfo:state => state.user.userInfo,
    isJudges:state => state.user.isJudges,//是否评委
    menuList: state => state.app.menuList,
}
export default getters;
